import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const checkboxLabelBase = css`
  display: flex;
  flex: 1;
  flex-direction: row;
  min-width: 0;
  cursor: pointer;
  color: var(--neutral-black-base);
  position: relative;
`;

export const checkboxLabelDisabledState = css`
  cursor: default;
  color: var(--neutral-black-40);
`;

export const checkboxLabelForeground = css`
  position: relative;
  z-index: 1;
  display: flex;
  flex: 1;
  flex-direction: row;
  min-width: 0;
`;

export const checkboxLabelTextSpan = css`
  align-self: center;
  flex-grow: 1;
  margin: ${spacing.base}px 0 0 ${spacing.xs}px;
  ${responsiveText.BODY.MD};
`;

export const checkboxWrapper = css`
  margin: 0;
  flex: 1;
`;

export const checkboxWrapperContainer = css`
  display: flex;
  position: relative;
  padding-bottom: ${spacing.sm}px;
`;

export const linkUnderlay = css`
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: auto;
`;

export const secondaryLabel = css`
  align-self: center;
  text-align: right;
  ${responsiveText.BODY.SM};
  color: var(--neutral-black-40);
  font-weight: 400;
  margin-top: ${spacing.base}px;
`;
